module.exports = __webpack_public_path__ + "img/stringInverter.dd6fcf4e.svg";